import "./App.css";

// Importing Components
import {AuthProvider} from './contexts/AuthContext';
import PrivateRoute from './PrivateRoute';

import HomePage from './components/HomepageComponents/Homepage';
import AboutUs from './components/AboutUsComponent/AboutUs';
import Blogs from './components/BlogsComponent/Blogs';
import Calculators from './components/CalculatorsComponents/Calculators';
import IntrinsicValueCalculator from './components/CalculatorsComponents/IntrinsicValueCalculator/IntrinsicValueCalculator';
import Rule72Calculator from './components/CalculatorsComponents/Rule72Calculator/Rule72Calculator';
import ContactUs from './components/ContactUsComponent/ContactUs';
import Faq from './components/FaqComponent/Faq';
import Footer from './components/FooterComponents/Footer';
import Header from './components/HeaderComponents/Header';
import Login from './components/LoginComponents/Login';
import Signup from './components/SignupComponents/Signup';
import Modules from './components/ModulesComponents/Modules';
import StockMarketModules from './components/ModulesComponents/StockMarketModulesComponent/StockMarketModules';
import MutualFundsModules from './components/ModulesComponents/MutualFundsModulesComponent/MutualFundsModules';
import News from './components/NewsComponents/News';
import Profile from './components/ProfileComponents/Profile';
import StockAnalysis from './components/StockAnalysisComponent/StockAnalysis';
import StockComparison from './components/StockComparisonComponents/StockComparison';
import StockReview from './components/StockReviewComponent/StockReview';
import PageNotFound from "./components/PageNotFoundComponent/PageNotFound";


// Importing npm 
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';

function App() {
	return (
		<div className="App">
			<Router>
				<AuthProvider>
					<Header/>
					<Switch>
						<Route exact path="/" component={HomePage} />
						<Route exact path="/login" component={Login} />
						<Route exact path="/calculators" component={Calculators}/>
						<Route exact path="/intrinsicvaluecalculator" component={IntrinsicValueCalculator} />
						<Route exact path="/signup" component={Signup} />
						<PrivateRoute path="/profile" component={Profile} />
						<Route component={PageNotFound}/>
					</Switch>
					<Footer/>
				</AuthProvider>
			</Router>
		</div>
	);
}

export default App;
